import React from 'react';

const Error = () => (
  <div className="SectionContainer">
    <div className="ChalkBoard SectionContentContainer">
      <div className="SectionContent">
        404: Page not found!
      </div>
    </div>
  </div>
);

export default Error;
